module.exports = __webpack_public_path__ + "img/jhPageJimeng1.fe742f35.png";